
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuLunchLateHarajukuLateLunchImage } from "@src/constants/images";
import { meta as ryunokoPancakePageMeta } from "./ryunoko.mdx";
import { meta as kevelosPageMeta } from "./kevelos.mdx";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as afuriPageMeta } from "./afuri.mdx";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
export const meta = {
  path: "/media/harajuku/lunch_late",
  title: "【名店】原宿で14時以降の遅めのランチができるお店8選",
  description: "原宿で遅めの時間帯にランチが食べられるお店を8店舗ご紹介します。百名店選出実績があるお店、食べログの評価が高評価のお店、ミシュランに掲載実績があるお店をはじめとした名店を選びました。また、ジャンル別に掲載しているので、その日の気分に合わせてランチを選ぶことができるようになっています。14時以降の遅めのランチを原宿で食べたい時に、こちらの記事を確認してみてください。",
  topImg: harajukuLunchLateHarajukuLateLunchImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "まとめ記事", "大人向け", "遅めランチ", "ミシュラン掲載"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で遅めの時間帯にランチが食べられるお店を 8 店舗ご紹介します。`}</p>
    <p>{`百名店選出実績があるお店、食べログの評価が高評価のお店、ミシュランに掲載実績があるお店をはじめとした名店を選びました。`}</p>
    <p>{`また、ジャンル別に掲載しているので、その日の気分に合わせてランチを選ぶことができるようになっています。`}</p>
    <p>{`そのお店の人気のメニューを写真付きで公開しているので、イメージを持って 14 時以降の遅めのランチを原宿で食べたい時に、こちらの記事を確認してみてください。`}</p>
    <h2>{`【ハンバーガー】ザ グレートバーガー`}</h2>
    <InstaImage postId="CA91dbQhB33" mdxType="InstaImage" />
    <p>{`「裏原」に位置する原宿ハンバーガーの有名店が「 ザ グレートバーガー 」。原宿の店舗は食べログの評価が 3.7 を超え、百名店に 3 年連続選出されるほどの名店。原宿のランチを調べると必ずといっていいほど出てくるお店なので、ご存知の方も多いのではないでしょうか。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`11:30 ～ 23:00 の終日営業なので、時間を気にすることなく遅めの時間帯でもランチができるのがザ グレートバーガー の魅力です。
原宿でちょっと遅めのランチをガッツリ食べたい時におすすめのお店になります！`}</p>
    <h3>{`アボカドモッツァレラバーガー`}</h3>
    <InstaImage postId="BbGD99MnyZT" mdxType="InstaImage" />
    <p>{`ハンバーガの種類は十数種類と豊富にありますが、1 番有名なメニューが、アボカドモッツァレラバーガー。
店内、テイクアアウト、デリバリー問わず一番人気で、塩気のある肉肉しいハンバーガーとアボカドの旨味が凝縮された一品。
ボリューム感満点のバーガーには、フレンチフライとドリンクがついています。`}</p>
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brag1o223akg00evu3bg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カレー】みのりんご`}</h2>
    <InstaImage postId="B_msNzYAyA9" mdxType="InstaImage" />
    <p>{`ザ グレートバーガーと同じく、原宿 ランチで検索すると必ずといっていいほど出てくるのでみのりんご 。独特のスパイスの効いたキーマカレーに、たっぷりとチーズをトッピングしたカレーが有名で、インスタグラムにたくさんの写真が投稿されています。`}</p>
    <p>{`食べログの評価は 3.7 を超え、百名店にも選出されるほどの人気店でも遅めのランチが食べられるのが特徴です。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`平日は 15 時までランチを食べることができ、休日は終日営業しているので、夕方頃の時間帯でもランチでカレーが食べられます。
遅めの時間に、原宿でスパイスの効いたカレーのランチが食べたい時にはみのりんごがおすすめです！`}</p>
    <h3>{`とろーりチーズのキーマカレー`}</h3>
    <InstaImage postId="CA1bIQdAi4Y" mdxType="InstaImage" />
    <p>{`先ほどインスタグラムにたくさんの写真が載っているとご紹介したのが、こちらのとろーりチーズのキーマカレー。
1 番人気のランチメニューで、数十時間かけて作るスパイスの効いたキーマカレーに、とろとろのたっぷりとしたチーズがトッピングされており、ピンクグローブの香りがキーマカレーの味を引き立てるメニューになっています。`}</p>
    <h3>{`ポークカレー`}</h3>
    <InstaImage postId="B-3pu33jd9x" mdxType="InstaImage" />
    <p>{`他にも多数のメニューがありますが、ランチでコアなファン人気のメニューがこちらの辛口ポークカレー。
柔らかいスペアリブが入っていて、食感も楽しめる一品。辛いのが得意な方は、ぜひ挑戦してみてください。`}</p>
    <LinkWithThumbnail meta={minoringoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="br5tsra23akg00ac688g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】ミカサデコ＆カフェ`}</h2>
    <InstaImage postId="B-ZnzvKHE90" mdxType="InstaImage" />
    <p>{`裏原から少し外れたところに位置する隠れ家的なお店がミカサデコ＆カフェ。2020 年に移転したばかりで、お店の外観と内装は清潔でスタイリッシュな外観。「大人が楽しめるカフェ」をコンセプトにしており、原宿の都会の喧騒を忘れるような落ち着いた雰囲気でランチができるのが特徴。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`9:00 ～ 19:00 の終日営業なので、遅めの時間になっても気軽ランチができるのが特徴！`}</p>
    <p>{`カフェでゆっくりランチを楽しみたい方には、ミカサデコ＆カフェがおすすめです！`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="CAFlJvZltqH" mdxType="InstaImage" />
    <InstaImage postId="B-GrwQBD0kj" mdxType="InstaImage" />
    <p>{`カレーた野菜を使ったメニュー、ビーフストロガノフなど、たくさんの食べがいのあるメニューが揃っているのも人気の秘密。その日の気分に合わせて、ランチを選べるのは嬉しいですよね！`}</p>
    <ShopInfoBox shopId="breespi23akg00eoptr0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【中華】龍の子`}</h2>
    <InstaImage postId="B572d5tn5Ll" mdxType="InstaImage" />
    <p>{`原宿の竹下通りを抜けてすぐの角を右に曲がったスターバックスの手前のビルに位置します。
本格的な四川料理が食べられるとして原宿で有名なお店で、1977 年創業の老舗でありながら、食べログの評価は 3.7 を超えるなど、長い年月原宿で愛され続けてきた中華の名店が龍の子になります。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`15 時までランチをやっていて、ラストオーダーは 14:30 になっています。月曜〜土曜までランチの時間帯は同じなので、休日は長いということはないので、遅めの時間帯に行く時は注意してください。
原宿付近で用事があって、14 時頃に原宿にいる時には、ギリギリ滑り込めるかもしれませんね！`}</p>
    <h3>{`麻婆豆腐のランチセット`}</h3>
    <InstaImage postId="B4FWP2kn3mo" mdxType="InstaImage" />
    <p>{`辛さと痺れを調整できる本格四川風麻婆豆腐がランチでお手頃価格で食べられます。副菜、スープ、ご飯がついたボリューム感のあるランチ。
中華好きの方や、本格的に中華が食べたいと思った時には龍の子がおすすめです！`}</p>
    <LinkWithThumbnail meta={ryunokoPancakePageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brf4bdi23akg00d4ds20" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【ラーメン】AFURI`}</h2>
    <InstaImage postId="B-7UwnvnUuw" mdxType="InstaImage" />
    <p>{`AFURI の柚子塩らーめんは全国のコンビニエンスストアでも販売されているので、ご存知の方も多いのではないでしょうか。AFURI は外国人のお客様が半分を占めると言われるほど人気のお店で、ミシュランにも掲載実績があるほどの実力店。原宿ラーメンの中でも存在感を放つお店になっています。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`10:00 ～ 23:30 の終日営業なので、遅めの時間でもいつ行っても安心なのが AFURI の魅力です。ラーメンをランチで食べたい時に、時間を気にせずにお店に行けるのは安心感があって良いですよね。`}</p>
    <h3>{`柚子塩らーめん`}</h3>
    <InstaImage postId="B-xCZBODKze" mdxType="InstaImage" />
    <p>{`看板メニューは 1000 円以下で食べられ、爽やかな柚子皮がラーメンの味を引き立てています！`}</p>
    <p>{`チャーシューは炙りチャーシューと、ヘルシーな鳥チャーシューから選ぶことができます。`}</p>
    <p>{`北海道産の全粒粉とライ麦を配合した細麺の食感を楽しむことができ、阿夫利山の天然水でじっくりと炊き上げたこだわりのあるスープを、人気で熱続けられる理由なのだと思います！`}</p>
    <LinkWithThumbnail meta={afuriPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brhpjf223akg00cq84ng" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【パン】レフェクトワール`}</h2>
    <InstaImage postId="By4opwZjxQ0" mdxType="InstaImage" />
    <p>{`原宿から駅徒歩 4 分の距離にあるタケオキクチビルに位置するのですが、少し発見するのが難しいかもしれません。
食べログの評価は 3.7 を超え、3 年連続百名店にも選出されている有名なパンのお店になります！`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`平日は 15:30 までがランチタイムで、`}<strong parentName="p">{`休日はランチはやってません`}</strong>{`。なので休日に原宿で遅めのランチを食べたい時には、レフェクトワールは食べられないので注意が必要です。平日の場合だと、遅めの時間帯でもランチが食べられるのでパン好きには嬉しいお店。`}</p>
    <h3>{`ランチセットがお得`}</h3>
    <InstaImage postId="vSaphbyzVh" mdxType="InstaImage" />
    <InstaImage postId="B7lMS6FAGZl" mdxType="InstaImage" />
    <p>{`サラダとドリンクのランチセットが 1,020 円とお得なお値段で食べられます！`}</p>
    <p>{`クロックムッシュやキッシュ、サラダ、スープの 4 種類か好きなものをランチでは選ぶことができ、パンだけでなくマフィンも豊富に取り揃えられているので、その日の気分に合わせてランチをカスタマイズして食べてみるのがオススメです！`}</p>
    <ShopInfoBox shopId="brf4aea23akg00d4drsg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】ウズナオムオム`}</h2>
    <p>{`原宿で隠れ家的なお店がウズナオムオム。マンションの二階にあるお店なので、初めて行く方は見つけるのが難しくびっくりするかもしれませんが、入ってみるとアットホームな空間でリピートしてしまうくらい居心地が良いです。`}</p>
    <p>{`パンケーキがメインのお店として人気ですが、カレーやランチプレートなど、ランチとしても利用できる便利なお店です。
食べログの評価は 3.6 を超え、実力も指折りの名店。`}</p>
    <h3>{`ランチの時間帯`}</h3>
    <p>{`12:00 ～ 18:00(L.O.17:00)となっているので、平日も休日も遅めのランチの時間帯でも安心してランチを食べられるのが特徴。遅めの時間帯になって、空いていないということはないので、ランチが食べたい時には候補の一つとして考えてみてください。`}</p>
    <h3>{`サーモンとカマンベールチーズのパンケーキ`}</h3>
    <InstaImage postId="B1iTQ8inBBO" mdxType="InstaImage" />
    <p>{`もちもちのパンケーキにサーモンとカマンベールをふんだんに使ったランチメニュー。パンケーキだけ食べても美味しいし、サーモンやカマンベールと一緒に食べても美味しい一品。
その他にもカレーなどのメニューもあるので、お店に行ってから決めてみるのがおすすめです。`}</p>
    <LinkWithThumbnail meta={uzunaomomPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brd4mqq23akg009mvap0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿で遅めのランチが食べられるお店をご紹介してきましたが、いかがでしたでしょうか。
平日と休日で営業時間が違うところは注意しないといけないですが、名店の味が遅い時間でも食べられるのは嬉しいですよね。特にランチ激戦区と言われる原宿で行列が並んでいることも多いので、遅めの時間帯だと混雑を避けて名店の味にたどり着くことができるかもしれません！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;